import { render, staticRenderFns } from "./AdminFileGroups.vue?vue&type=template&id=ed033784&scoped=true"
import script from "./AdminFileGroups.vue?vue&type=script&lang=js"
export * from "./AdminFileGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed033784",
  null
  
)

export default component.exports